// ── Chart / Analytics Data ──
export const APPROVAL_TRENDS = [
  { month: "Aug", approved: 28, rejected: 8,  pending: 15 },
  { month: "Sep", approved: 35, rejected: 12, pending: 20 },
  { month: "Oct", approved: 42, rejected: 10, pending: 18 },
  { month: "Nov", approved: 38, rejected: 15, pending: 22 },
  { month: "Dec", approved: 50, rejected: 8,  pending: 25 },
  { month: "Jan", approved: 45, rejected: 11, pending: 19 },
  { month: "Feb", approved: 58, rejected: 9,  pending: 28 },
];

export const USER_ACTIVITY = [
  { day: "Mon", logins: 24, actions: 67 },
  { day: "Tue", logins: 31, actions: 84 },
  { day: "Wed", logins: 28, actions: 72 },
  { day: "Thu", logins: 35, actions: 91 },
  { day: "Fri", logins: 29, actions: 78 },
  { day: "Sat", logins: 12, actions: 34 },
  { day: "Sun", logins: 8,  actions: 22 },
];

export const CAT_DATA = [
  { name: "Baby Food", value: 34, color: "#0C6170" },
  { name: "Dairy",     value: 22, color: "#37BEB0" },
  { name: "Snacks",    value: 18, color: "#A4E5E0" },
  { name: "Cereals",   value: 14, color: "#5ba8a2" },
  { name: "Beverages", value: 12, color: "#DBF5F0" },
];

// ── Initial Products ──
export const INITIAL_PRODUCTS = [
  {
    id: "p001", name: "Nestlé Ceregrow Multigrain", brand: "Nestlé",
    category: "Baby Food", status: "pending", emoji: "🍼",
    bg: "rgba(55,190,176,.12)", createdDate: "2024-01-15",
    createdBy: "editor@zytama.com",
    description: "A multigrain cereal for toddlers enriched with 15 essential nutrients including iron, calcium and vitamins.",
    ingredients: "<ul><li>Wheat flour</li><li>Milk solids</li><li>Sugar</li><li>Rice flour</li><li>Corn flour</li><li>Vitamins & Minerals premix</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>420 kcal</td></tr><tr><td>Protein</td><td>10g</td></tr><tr><td>Fat</td><td>8g</td></tr><tr><td>Carbohydrate</td><td>72g</td></tr><tr><td>Iron</td><td>7.5mg</td></tr></table>",
    approvedBy: null, approvedDate: null, rejectReason: null,
    ageGroup: "1_2_years",
  },
  {
    id: "p002", name: "Amul Taaza Toned Milk", brand: "Amul",
    category: "Dairy", status: "approved", emoji: "🥛",
    bg: "rgba(12,97,112,.08)", createdDate: "2024-01-12",
    createdBy: "moderator@zytama.com",
    description: "Toned milk with 3% fat content, pasteurized and homogenized for daily consumption.",
    ingredients: "<ul><li>Toned milk</li><li>Vitamin A</li><li>Vitamin D</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>58 kcal</td></tr><tr><td>Protein</td><td>3g</td></tr><tr><td>Fat</td><td>3g</td></tr><tr><td>Carbohydrate</td><td>4.8g</td></tr><tr><td>Calcium</td><td>120mg</td></tr></table>",
    approvedBy: "superadmin@zytama.com", approvedDate: "2024-01-13", rejectReason: null,
    ageGroup: "3_5_years",
  },
  {
    id: "p003", name: "Britannia NutriChoice Digestive", brand: "Britannia",
    category: "Snacks", status: "rejected", emoji: "🍪",
    bg: "rgba(164,229,224,.15)", createdDate: "2024-01-10",
    createdBy: "editor@zytama.com",
    description: "High fibre digestive biscuits made with whole wheat for a healthier snacking option.",
    ingredients: "<ul><li>Whole wheat flour</li><li>Sugar</li><li>Edible vegetable oil</li><li>Dietary fibre</li><li>Milk solids</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>462 kcal</td></tr><tr><td>Protein</td><td>7g</td></tr><tr><td>Fat</td><td>17g</td></tr><tr><td>Carbohydrate</td><td>68g</td></tr><tr><td>Fibre</td><td>5g</td></tr></table>",
    approvedBy: null, approvedDate: null, rejectReason: "Nutritional claims need third-party verification. Please provide lab test reports.",
    ageGroup: "7_10_years",
  },
  {
    id: "p004", name: "Kellogg's Chocos Fills", brand: "Kellogg's",
    category: "Cereals", status: "approved", emoji: "🥣",
    bg: "rgba(55,190,176,.1)", createdDate: "2024-01-08",
    createdBy: "moderator@zytama.com",
    description: "Crunchy chocolate-filled pillows made with wheat, rice and corn for a fun breakfast.",
    ingredients: "<ul><li>Wheat flour</li><li>Sugar</li><li>Cocoa solids</li><li>Rice flour</li><li>Corn flour</li><li>Edible vegetable oil</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>395 kcal</td></tr><tr><td>Protein</td><td>6g</td></tr><tr><td>Fat</td><td>9g</td></tr><tr><td>Carbohydrate</td><td>73g</td></tr><tr><td>Iron</td><td>8.7mg</td></tr></table>",
    approvedBy: "superadmin@zytama.com", approvedDate: "2024-01-09", rejectReason: null,
    ageGroup: "5_7_years",
  },
  {
    id: "p005", name: "Tropicana 100% Orange Juice", brand: "Tropicana",
    category: "Beverages", status: "pending", emoji: "🧃",
    bg: "rgba(219,245,240,.3)", createdDate: "2024-01-05",
    createdBy: "editor@zytama.com",
    description: "100% pure squeezed orange juice with no added sugar or preservatives.",
    ingredients: "<ul><li>100% Orange juice</li><li>Vitamin C</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>45 kcal</td></tr><tr><td>Protein</td><td>0.7g</td></tr><tr><td>Fat</td><td>0.2g</td></tr><tr><td>Carbohydrate</td><td>10g</td></tr><tr><td>Vitamin C</td><td>40mg</td></tr></table>",
    approvedBy: null, approvedDate: null, rejectReason: null,
    ageGroup: "3_5_years",
  },
  {
    id: "p006", name: "ITC Sunfeast Mom's Magic", brand: "ITC",
    category: "Snacks", status: "approved", emoji: "🍘",
    bg: "rgba(12,97,112,.06)", createdDate: "2024-01-03",
    createdBy: "editor@zytama.com",
    description: "Rich butter cookies made with real butter for a homestyle taste.",
    ingredients: "<ul><li>Wheat flour</li><li>Sugar</li><li>Butter</li><li>Edible vegetable oil</li><li>Milk solids</li><li>Salt</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>480 kcal</td></tr><tr><td>Protein</td><td>5g</td></tr><tr><td>Fat</td><td>22g</td></tr><tr><td>Carbohydrate</td><td>65g</td></tr></table>",
    approvedBy: "superadmin@zytama.com", approvedDate: "2024-01-04", rejectReason: null,
    ageGroup: "5_7_years",
  },
  {
    id: "p007", name: "Dabur Honey Pure", brand: "Dabur",
    category: "Supplements", status: "pending", emoji: "🍯",
    bg: "rgba(55,190,176,.08)", createdDate: "2024-01-01",
    createdBy: "moderator@zytama.com",
    description: "100% pure honey sourced from natural apiaries with no added sugar.",
    ingredients: "<ul><li>100% Natural honey</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>320 kcal</td></tr><tr><td>Protein</td><td>0.3g</td></tr><tr><td>Fat</td><td>0g</td></tr><tr><td>Carbohydrate</td><td>80g</td></tr></table>",
    approvedBy: null, approvedDate: null, rejectReason: null,
    ageGroup: "2_3_years",
  },
  {
    id: "p008", name: "Paper Boat Aam Panna", brand: "Paper Boat",
    category: "Beverages", status: "rejected", emoji: "🥭",
    bg: "rgba(164,229,224,.12)", createdDate: "2023-12-28",
    createdBy: "editor@zytama.com",
    description: "Traditional raw mango drink made with real fruit pulp and cumin.",
    ingredients: "<ul><li>Water</li><li>Sugar</li><li>Raw mango pulp</li><li>Cumin extract</li><li>Mint extract</li><li>Salt</li></ul>",
    nutrients: "<table><tr><td>Energy</td><td>55 kcal</td></tr><tr><td>Protein</td><td>0g</td></tr><tr><td>Fat</td><td>0g</td></tr><tr><td>Carbohydrate</td><td>14g</td></tr></table>",
    approvedBy: null, approvedDate: null, rejectReason: "Missing FSSAI certification number on packaging details.",
    ageGroup: "5_7_years",
  },
];

// ── Initial Users ──
export const INITIAL_USERS = [
  { id: "u1", name: "Vikram Singh",   email: "superadmin@zytama.com",  role: "super_admin", status: "active",   createdDate: "2023-11-01" },
  { id: "u2", name: "Priya Patel",    email: "moderator@zytama.com",   role: "moderator",   status: "active",   createdDate: "2023-11-15" },
  { id: "u3", name: "Amit Kumar",     email: "editor@zytama.com",      role: "editor",      status: "active",   createdDate: "2023-12-01" },
  { id: "u4", name: "Sneha Gupta",    email: "sneha@zytama.com",       role: "editor",      status: "active",   createdDate: "2024-01-05" },
  { id: "u5", name: "Rahul Sharma",   email: "rahul@zytama.com",       role: "moderator",   status: "inactive", createdDate: "2023-12-20" },
  { id: "u6", name: "Ananya Reddy",   email: "ananya@zytama.com",      role: "editor",      status: "active",   createdDate: "2024-01-10" },
];

// ── Activities ──
export const ACTIVITIES = [
  { id: 1, type: "approve", product: "Amul Taaza Toned Milk",       user: "Vikram Singh", time: "2 hours ago" },
  { id: 2, type: "edit",    product: "Nestlé Ceregrow Multigrain",  user: "Amit Kumar",   time: "4 hours ago" },
  { id: 3, type: "reject",  product: "Britannia NutriChoice",       user: "Priya Patel",  time: "6 hours ago" },
  { id: 4, type: "approve", product: "ITC Sunfeast Mom's Magic",    user: "Vikram Singh", time: "1 day ago" },
  { id: 5, type: "edit",    product: "Dabur Honey Pure",            user: "Sneha Gupta",  time: "1 day ago" },
  { id: 6, type: "reject",  product: "Tropicana Orange Juice",      user: "Priya Patel",  time: "2 days ago" },
];

// ── Reference data ──
export const CATEGORIES = ["Baby Food", "Dairy", "Snacks", "Cereals", "Beverages", "Supplements", "Fruits & Veg"];

export const AGE_GROUPS_DISPLAY = {
  "0_6_months": "0–6 Months",
  "6_12_months": "6–12 Months",
  "1_3_years": "1–3 Years",
  "3_5_years": "3–5 Years",
  "5_8_years": "5–8 Years",
  "8_12_years": "8–12 Years",
  // Stage-aligned keys (matching product_score_v2 C1–C4 labels)
  "2_3_years": "2–3 Years",
  "4_6_years": "4–6 Years",
  "7_9_years": "7–9 Years",
  "10_12_years": "10–12 Years",
  // Retired 4-bucket-narrower keys, kept so any already-saved record
  // (or the demo data below) still renders a friendly label.
  "1_2_years": "1–2 Years",
  "5_7_years": "5–7 Years",
  "7_10_years": "7–10 Years",
};

export const ROLE_LABELS = { admin: "Admin", super_admin: "Super Admin", moderator: "Moderator", editor: "Editor", data_collection_agent: "Data Collection Agent", reviewer: "Reviewer" };
export const ROLE_COLORS = { admin: "b-sa", super_admin: "b-sa", moderator: "b-mod", editor: "b-ed", data_collection_agent: "b-ed", reviewer: "b-mod" };

export const PERMS = {
  admin:       ["dash", "products", "edit_p", "approve", "reject", "users", "create_u", "edit_u", "del_u"],
  super_admin: ["dash", "products", "edit_p", "approve", "reject", "users", "create_u", "edit_u", "del_u"],
  moderator:   ["dash", "products", "edit_p", "approve", "reject"],
  editor:      ["dash", "products", "edit_p"],
  data_collection_agent: ["dash", "products", "edit_p"],
  reviewer:    ["dash", "products", "edit_p", "approve", "reject"],
};

// ── Utility helpers ──
export const can = (role, perm) => (PERMS[role] || []).includes(perm);

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-";

export const avText = (s) => {
  if (!s) return "--";
  const p = s.split(" ");
  return ((p[0]?.[0] || "") + (p[1]?.[0] || "")).toUpperCase();
};

export const avColors = ["#0C6170", "#37BEB0", "#5ba8a2", "#2a8f88", "#0a5562"];
export const avBg = (s) => `${avColors[(s?.charCodeAt(0) || 65) % avColors.length]}22`;
export const avFg = (s) => avColors[(s?.charCodeAt(0) || 65) % avColors.length];
